import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.png';


const Sidebar = ({isStaff, isAdmin, userData}) => {
        const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const [showLogout, setShowLogout] = useState(false);
 const [permissions, setPermissions] = useState([]);
 
        const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };


     useEffect(() => {
        if (isStaff && userData?.permission) {
            try {
                const parsedPermissions = JSON.parse(userData.permission);
                setPermissions(parsedPermissions);
            } catch (e) {
                console.error('Error parsing permissions:', e);
            }
        }
    }, [userData, isStaff]);



    const handleLogout = () => {
        localStorage.removeItem('userData');
        if(isAdmin) {
        localStorage.removeItem('isAdmin', 'true');
        navigate('/admin-login');
        }
        if(isStaff) {
        localStorage.removeItem('isStaff', 'true');
        navigate('/staff-login');
        }
        window.location.reload();
    }

  return (
    <>
                  <div className={`sidebar-area ${collapsed ? "" : "collapsed"}`}>

                <span className="w-auto sidebar-item py-2 px-2" onClick={toggleSidebar}>
                    <i className={`fa-solid ${collapsed ? "fa-angle-left" : "fa-angle-right"}`}></i>
                </span>

                <div className='text-center'>
                    <img src={Logo} className='sidebar-logo' alt='Logo Sidebar' />
                </div>

{isAdmin && (
                    <div className='mt-4'>
                        <p className='sidebar-item' onClick={() => { navigate('/'); setCollapsed(false) }}><i class="fa-regular fa-chart-bar"></i><Link className='sidebar-text'>Dashboard</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/manage-profile'); setCollapsed(false) }}><i class="fa-regular fa-circle-user"></i><Link className='sidebar-text'>Manage Profile</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/inventory'); setCollapsed(false) }}><i class="fa-regular fa-bookmark"></i><Link className='sidebar-text'>Inventory</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/added-coupons'); setCollapsed(false) }}><i class="fa-solid fa-money-bill"></i><Link className='sidebar-text'>Added Coupons</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/view-users'); setCollapsed(false) }}><i class="fa-solid fa-users"></i><Link className='sidebar-text'>View Users</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/manage-orders'); setCollapsed(false) }}><i class="fa-solid fa-shopping-bag"></i><Link className='sidebar-text'>Manage Orders</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/view-party'); setCollapsed(false) }}><i class="fa-solid fa-eye"></i><Link className='sidebar-text'>View Parties</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/add-sale'); setCollapsed(false) }}><i class="fa-solid fa-receipt"></i><Link className='sidebar-text'>Add Sale</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/sale-history'); setCollapsed(false) }}><i class="fa-solid fa-clock-rotate-left"></i><Link className='sidebar-text'>Sale History</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/reports'); setCollapsed(false) }}><i class="fa-solid fa-chart-line"></i><Link className='sidebar-text'>Reports</Link></p>


                        <p className='sidebar-item' onClick={() => { navigate('/add-purchase'); setCollapsed(false) }}><i class="fa-solid fa-cart-shopping"></i><Link className='sidebar-text'>Add Purchase</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/purchase-history'); setCollapsed(false) }}><i class="fa-solid fa-clock-rotate-left"></i><Link className='sidebar-text'>Purchase History</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/manage-staff'); setCollapsed(false) }}><i class="fa-solid fa-layer-group"></i><Link className='sidebar-text'>Manage Staff</Link></p>
                        <p className='sidebar-item' onClick={() => { navigate('/enquiry'); setCollapsed(false) }}><i class="fa-solid fa-mobile-screen-button"></i><Link className='sidebar-text'>Site Enquiry</Link></p>
                        <p className='sidebar-item' onClick={() => { setShowLogout(true) }}><i class="fa-solid fa-power-off"></i><Link className='sidebar-text'>Log Out</Link></p>
</div>
)}

{isStaff && (
  <div className='mt-4'>
    <p className='sidebar-item' onClick={() => { navigate('/'); setCollapsed(false) }}>
      <i className="fa-regular fa-chart-bar"></i><Link className='sidebar-text'>Dashboard</Link>
    </p>

    {permissions.includes('Inventory') &&
      <p className='sidebar-item' onClick={() => { navigate('/inventory'); setCollapsed(false) }}>
        <i className="fa-regular fa-bookmark"></i><Link className='sidebar-text'>Inventory</Link>
      </p>
    }

    {permissions.includes('Coupons') &&
      <p className='sidebar-item' onClick={() => { navigate('/added-coupons'); setCollapsed(false) }}>
        <i className="fa-solid fa-money-bill"></i><Link className='sidebar-text'>Added Coupons</Link>
      </p>
    }

    {permissions.includes('Add Party') &&
      <p className='sidebar-item' onClick={() => { navigate('/view-party'); setCollapsed(false) }}>
        <i className="fa-solid fa-eye"></i><Link className='sidebar-text'>View Parties</Link>
      </p>
    }

    {permissions.includes('User Management') &&
      <p className='sidebar-item' onClick={() => { navigate('/view-users'); setCollapsed(false) }}>
        <i className="fa-solid fa-users"></i><Link className='sidebar-text'>View Users</Link>
      </p>
    }

    {permissions.includes('Add Purchase') && (
      <>
        <p className='sidebar-item' onClick={() => { navigate('/add-purchase'); setCollapsed(false) }}>
          <i className="fa-solid fa-cart-shopping"></i><Link className='sidebar-text'>Add Purchase</Link>
        </p>
          <p className='sidebar-item' onClick={() => { navigate('/purchase-history'); setCollapsed(false) }}>
            <i className="fa-solid fa-clock-rotate-left"></i><Link className='sidebar-text'>Purchase History</Link>
          </p>
      </>
    )}

                            <p className='sidebar-item' onClick={() => { setShowLogout(true) }}><i class="fa-solid fa-power-off"></i><Link className='sidebar-text'>Log Out</Link></p>

  </div>
)}


                <span className="sidebar-btn py-2" onClick={toggleSidebar}>
                    <i className={`fa-solid ${collapsed ? "fa-angle-left" : "fa-angle-right"}`}></i>
                </span>
                </div>

                            {showLogout && (
                <section className='detail-dialog' onClick={() => setShowLogout(false)}>
                    <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='sidebar-menu-title'>Really want to Log Out?</p>

                        <button className='edit-btn' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
                        <button className='close-btn' onClick={() => setShowLogout(false)}>No</button>

                    </div>
                </section>
            )}
    </>
  )
}

export default Sidebar
